import { render, staticRenderFns } from "./PFSettlementReason.vue?vue&type=template&id=15034153"
import script from "./PFSettlementReason.vue?vue&type=script&lang=js"
export * from "./PFSettlementReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports